<template>
  <Page subpage>
    <div class="flex justify-between items-center mb-4">
      <h3 class="page-header-2">Departments</h3>
      <SlotWrapper>
        <template #header>
          <Button data-cy="new-department" @click="openDepartmentModal()">
            New
          </Button>
        </template>
      </SlotWrapper>
    </div>
    <div class="datatable-report">
      <div class="datatable-v3 overflow-auto">
        <table class="w-full">
          <thead>
            <tr>
              <th scope="col">Name</th>
              <th scope="col">Techs</th>
              <th scope="col">Timezone</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="department in departments" :key="department.id">
              <td class="departmentName" data-cy="departmentName">
                <ArchivedLabel
                  hide-archived-text
                  :disabled="!department.archived"
                >
                  <span
                    class="link"
                    @click="openDepartmentModal(department.id)"
                    >{{ department.name }}</span
                  >
                  <span v-if="department.has_dirty_prices">
                    &nbsp;<a :href="department.resource_url + '/pricebook'">
                      <i
                        class="fa fa-exclamation-triangle fa-fw text-warning"
                        title="Prices for this department are outdated."
                    /></a>
                  </span>
                </ArchivedLabel>
              </td>
              <td>
                <a :href="department.resource_url + '/technicians'">{{
                  department.size
                }}</a>
              </td>
              <td>
                {{ department.timezone }}
              </td>
            </tr>
          </tbody>
        </table>
        <DepartmentModal
          v-if="isDepartmentModalOpen"
          :department-id="currentDepartmentId"
          @hide-modal="toggleDepartmentModal"
          @reload-departments="fetchDepartments"
        />
      </div>
    </div>
  </Page>
</template>

<script>
import { mapActions, mapState } from "vuex";

import ArchivedLabel from "@/components/ArchivedLabel.vue";
import Button from "@/components/Button.vue";
import Page from "../components/Page.vue";
import { getQueryVariables } from "../lib/url.js";
import DepartmentModal from "./DepartmentModal/DepartmentModal.vue";
import SlotWrapper from "@/components/SlotWrapper";

import("@/components/datatable_tailwind.css");

export default {
  components: {
    SlotWrapper,
    ArchivedLabel,
    DepartmentModal,
    Page,
    Button
  },
  data() {
    return {
      isDepartmentModalOpen: false,
      currentDepartmentId: null
    };
  },
  computed: {
    ...mapState(["departments"])
  },
  watch: {
    isDepartmentModalOpen(newValue, oldValue) {
      if (newValue !== oldValue && !newValue) {
        this.currentDepartmentId = null;
        this.clearCurrentDepartment();
      }
    }
  },
  mounted() {
    if (this.departments.length === 0) {
      this.fetchDepartments();
    }
    this.checkForEditId();
  },
  methods: {
    ...mapActions(["fetchDepartments", "clearCurrentDepartment"]),
    checkForEditId() {
      // Open dept edit modal from task price modal Finance Markup link
      const params = getQueryVariables();
      if (params.dept_id) {
        this.currentDepartmentId = params.dept_id;
        this.toggleDepartmentModal();
      }
    },
    toggleDepartmentModal() {
      this.isDepartmentModalOpen = !this.isDepartmentModalOpen;
    },
    openDepartmentModal(departmentId) {
      this.currentDepartmentId = departmentId;
      this.toggleDepartmentModal();
    }
  }
};
</script>

<style lang="css" scoped>
.new-button {
  color: white;
}
</style>
